<template>
  <h1 class="text-ui-kit-text mb-6 text-h6 text-md-h3">
    <slot />
  </h1>
</template>
